import {
  ParametricAssetId,
  SubmittingOrganization,
  type ParametricAsset,
} from "@/types";

type AssetParams = {
  L: number; // Longueur
  hg: number; // Hauteur gauche
  hd: number; // Hauteur droite
  lg: number; // Largeur plat gauche
  ld: number; // Largeur plat droite
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.WING_WALL,
  image: "/images/assets/mur-retour.png",
  submittedBy: SubmittingOrganization.ARS,
  inputs: [
    {
      key: "L",
      type: "dimension",
    },
    {
      key: "hg",
      type: "dimension",
    },
    {
      key: "hd",
      type: "dimension",
    },
    {
      key: "lg",
      type: "dimension",
    },
    {
      key: "ld",
      type: "dimension",
    },
  ],
  build: (params, offset) => {
    const { L, hg, hd, lg, ld } = params;
    return [
      {
        // center parallelogram
        type: "polyline",
        points: [
          [
            // bottom Left
            offset[0] - L / 2,
            offset[1] - hg / 2,
            offset[2],
          ],
          [
            // bottom right
            offset[0] + L / 2,
            offset[1] - hg / 2,
            offset[2],
          ],
          [
            // top right
            offset[0] + L / 2,
            offset[1] - hg / 2 + hd,
            offset[2],
          ],
          [
            // middle right
            offset[0] + L / 2 - ld,
            offset[1] - hg / 2 + hd,
            offset[2],
          ],
          [
            // middle Left
            offset[0] - L / 2 + lg,
            offset[1] + hg / 2,
            offset[2],
          ],
          [
            // top Left
            offset[0] - L / 2,
            offset[1] + hg / 2,
            offset[2],
          ],
          [
            // bottom Left
            offset[0] - L / 2,
            offset[1] - hg / 2,
            offset[2],
          ],
        ],
      },
    ];
  },
};

export default asset;
